import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddAccountSchema = () => {
  const { t } = useTranslation();

  return z.object({
    agreedToBudgetRules: z.boolean().refine((value) => value === true, {
      message: t("common.form.field.errors.required"),
    }),
  });
};

export type TAddAccountModalSchema = z.infer<
  ReturnType<typeof useAddAccountSchema>
>;
